import React, { createContext, useMemo } from 'react';
export var FormContext = createContext({});
export var FormContextProvider = function (_a) {
    var children = _a.children, validationCallback = _a.validationCallback, showErrorsOnInitialRender = _a.showErrorsOnInitialRender, readOnlyFieldRender = _a.readOnlyFieldRender, skipFieldsOnAutoSave = _a.skipFieldsOnAutoSave, previewElementStyle = _a.previewElementStyle;
    var memoizedValues = useMemo(function () { return ({
        validationCallback: validationCallback,
        showErrorsOnInitialRender: showErrorsOnInitialRender,
        readOnlyFieldRender: readOnlyFieldRender,
        previewElementStyle: previewElementStyle,
        skipFieldsOnAutoSave: skipFieldsOnAutoSave,
    }); }, [
        readOnlyFieldRender,
        validationCallback,
        showErrorsOnInitialRender,
        previewElementStyle,
        skipFieldsOnAutoSave,
    ]);
    return (React.createElement(FormContext.Provider, { value: memoizedValues }, children));
};
